module.exports = __webpack_public_path__ + "static/media/2017.eda43898.svg";